import { Version } from '../types';

export const getVersion = (version: string, versions: Version[]): Version => {
  const index = versions.findIndex(({ id }) => id === version);

  if (index === -1) {
    throw new Error(`IMGLY - Version ${version} not found in array`);
  }

  return versions[index];
};
